// The store report catalog, grouped the way the API groups it. Every card
// opens the one templated ReportView.

import { Link } from 'react-router';
import { BarChart3, Package, Users, Wallet, type LucideIcon } from 'lucide-react';
import { useScope } from '../../scope';
import { REPORTS, REPORT_GROUPS, slugOf, type ReportGroup } from './registry';

const GROUP_ICONS: Record<ReportGroup, LucideIcon> = {
  'Sales & operations': BarChart3,
  Money: Wallet,
  Staff: Users,
  Inventory: Package,
};

const GROUP_KEYS: Record<ReportGroup, string> = { 'Sales & operations': 'sales', Money: 'money', Staff: 'staff', Inventory: 'inventory' };

export function ReportIndex() {
  const { rid, sid } = useScope();
  const root = `/r/${rid}/s/${sid}/reports`;
  return (
    <>
      <div className="page-head">
        <div>
          <div className="overline">Store · Reports</div>
          <h1>Reports</h1>
        </div>
      </div>

      {REPORT_GROUPS.map((group) => {
        const Icon = GROUP_ICONS[group];
        return (
          <section key={group} style={{ marginBottom: 28 }} data-section={`group-${GROUP_KEYS[group]}`} aria-label={group}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingBottom: 8, borderBottom: '2px solid var(--ink)' }}>
              <Icon size={15} />
              <h2 style={{ fontSize: 12.5, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', margin: 0 }}>{group}</h2>
            </div>
            <div className="sub-list" style={{ maxWidth: 'none' }}>
              {REPORTS.filter((r) => r.group === group).map((r) => (
                <Link key={r.path} className="sub-card" to={`${root}/${slugOf(r.path)}`} data-report={r.path}>
                  <b>{r.title}</b>
                  <span>{r.blurb}</span>
                </Link>
              ))}
            </div>
          </section>
        );
      })}
    </>
  );
}
